import { all, call, put, takeLatest } from 'redux-saga/effects'
import api from '../../services/api.services'
import { addNotification } from '../notifications/NotificationActions'
import { INotification } from '../notifications/NotificationReducers'
import { changeUserLanguage } from './languageActions'
import { getErrorMsg } from '../helpers/translations'

export function* sagaChangeUserLanguage({ payload }: any) {
  try {
    yield call(api.users.changeUserLanguage, { lang: payload })
    window.location.reload()
  } catch (e: any) {
    const changeLanguageFailNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('language change'),
    }

    yield put({ type: String(addNotification), payload: changeLanguageFailNotification })
  }
}

export function* languageSagas() {
  yield all([takeLatest(String(changeUserLanguage), sagaChangeUserLanguage)])
}
